package fr.frux.core.maps

import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.calculateEndPadding
import androidx.compose.foundation.layout.calculateStartPadding
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.LayoutDirection
import androidx.compose.ui.unit.dp

/**
 * Hauteur de la rangée que le SDK occupe en bas de la carte plein écran : le bouton d'attribution
 * (40 dp d'après `AttributionDefaults.button` amont), plus l'écart que `MapOverlay.Spacing` (8 dp)
 * laisse entre lui et le bord de la zone dégagée.
 *
 * Publique parce que ce sont les écrans, pas `core-maps`, qui posent leurs contrôles flottants au
 * ras du bas : sans ce dégagement ils recouvrent le bouton, et le panneau qu'il déploie au
 * chargement passerait sous eux.
 */
val MAP_ATTRIBUTION_ROW_HEIGHT: Dp = 40.dp + 8.dp

/**
 * Marge de l'attribution des tuiles : hors des bords recouverts par l'écran carte ET par le chrome
 * racine (colonne grand écran). En hauteur, maximum et non somme : en compact, `contentPadding` et
 * `chromeInsets` décrivent tous deux la barre du bas. Sur les côtés, seul le chrome racine compte :
 * les marges latérales de `contentPadding` sont celles du cadrage caméra (48 dp pour ne pas coller
 * les marqueurs au bord), pas un chrome. Les reprendre posait le bouton d'attribution à 48 dp du
 * bord, à un endroit qui n'avait de sens pour personne. [bottomOverlayInset] : feuille du bas, qui
 * recouvre l'attribution sinon.
 */
fun attributionPadding(
    contentPadding: PaddingValues,
    chromeInsets: PaddingValues,
    layoutDirection: LayoutDirection,
    bottomOverlayInset: Dp = 0.dp,
): PaddingValues =
    PaddingValues(
        start = chromeInsets.calculateStartPadding(layoutDirection),
        top = maxOf(contentPadding.calculateTopPadding(), chromeInsets.calculateTopPadding()),
        end = chromeInsets.calculateEndPadding(layoutDirection),
        bottom =
            maxOf(
                contentPadding.calculateBottomPadding(),
                chromeInsets.calculateBottomPadding(),
                bottomOverlayInset,
            ),
    )
